'use client';
import { useFriendlyViewPort } from '../../hooks/useFriendlyViewPort';
import { useViewportSizeTracking } from '../../hooks/useViewportSizeTracking';
import { useVal, useValRoute } from '../../val/val.client';
import Link from 'next/link';
import headerVal from '../../settings/header.val';
import pageVal from '../../app/(main)/page.val';
import { notFound } from 'next/navigation';

const FrontPage = ({ params }: { params: Promise<never> }) => {
  const page = useValRoute(pageVal, params);
  const { navigationItems, contactItem } = useVal(headerVal);
  const links = navigationItems.concat(contactItem);

  useFriendlyViewPort();
  useViewportSizeTracking();

  const textStyle =
    'font-respira text-respira-lg tablet:text-respira-xl laptop:min-h-[0vh] leading-blank-tight transition-50ms break-words hyphens-manual text-pretty';

  if (!page) {
    return notFound();
  }

  const { title } = page;

  return (
    <>
      <div id="frontPage">
        <div className="laptop:h-screen pb-96">
          <div className="relative min-h-screen laptop:h-screen">
            <div className="flex flex-col laptop:justify-between laptop:items-center h-full px-16 laptop:px-24 laptop:flex-row gap-32 pt-[var(--header-height)] pb-32 laptop:pt-0 laptop:pb-0">
              <h1 className={`${textStyle} `}>{title}</h1>
              <div className="flex flex-col items-end gap-16 laptop:gap-24 laptop:top-[var(--header-height)] laptop:sticky shrink-0">
                {links.map((link) => (
                  <Link
                    href={link.url}
                    key={link.url}
                    className="text-2xl tablet:text-xl no-underline"
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { FrontPage };
